export const NAVIGATION_ROUTES = {
  DASHBOARD: "/",
  ADMIN: {
    BASE: "/admin",
    ADMIN: "/admin/admin",
    OVERVIEW: "/admin/overview",
    BULLETIN: {
      ADD_NEW_BULLETIN_NEPALI: "/admin/bulletin/add-new-bulletin-nepali",
      ADD_NEW_BULLETIN_ENGLISH: "/admin/bulletin/add-new-bulletin-english",
      DATATABLE: "/admin/bulletin/bulletin-data-table",
      EDIT: "/admin/bulletin/edit-bulletin/:urlLanguage/:id",
    },
    COVID19: {
      ADD: "/admin/covid-19/add-new-covid-19",
      DATATABLE: "/admin/covid-19/covid-19-data-table",
      BULK_UPLOAD: "/admin/covid-19/covid-19-bulk-upload",
    },
    EPIDEMICS: {
      ADD: "/admin/epidemics/add-new-epidemics",
      DATATABLE: "/admin/epidemics/epidemics-data-table",
      BULK_UPLOAD: "/admin/epidemics/epidemics-bulk-upload",
    },
    INCIDENT: {
      ADD: "/admin/incident/add-new-incident",
      BULK_UPLOAD: "/admin/incident/incident-bulk-upload",
      DATATABLE: "/admin/incident/incident-data-table",
    },
    TEMPORARY_SHELTER_ENROLLMENT_FORM: {
      DATATABLE:
        "/admin/temporary-shelter-enrollment-form/temporary-shelter-enrollment-form-data-table",
      DASHBOARD: "/admin/temporary-shelter-enrollment-form/dashboard",
      ADD: "/admin/temporary-shelter-enrollment-form/add-new-temporary-shelter-enrollment-data",
      DETAILS:
        "/admin/temporary-shelter-enrollment-form/add-new-temporary-shelter-enrollment-data-preview/:id",
    },
    HEALTH_INFRASTRUCTURE: {
      ADD: "/admin/health-infrastructure/add-new-health-infrastructure",
      DATATABLE:
        "/admin/health-infrastructure/health-infrastructure-data-table",
      BULK_UPLOAD:
        "/admin/health-infrastructure/health-infrastructure-bulk-upload",
    },
    GEO_HAZARD: {
      BASE: "/admin/geo-hazard",
      ASSESSMENT_REQUEST_FORM: "/admin/geo-hazard/assessment-request-form",
      FORM_PREVIEW: "/admin/geo-hazard/form-preview/:formId",
    },
  },
  PROFILE: {
    BASE: "/profile/",
    DEMOGRAPHY: "/profile/demography/",
    CONTACTS: "/profile/contacts/",
    DOCUMENTS: "/profile/documents/",
    PROJECTS: "/profile/projects/",
    NEPDAT_PROFILE: "/profile/nepDat-profile",
  },
  INCIDENTS: {
    BASE: "/incidents/",
    REPORT: "/incidents/:incidentId/response/",
  },
  DAMAGE_AND_LOSS: {
    BASE: "/damage-and-loss/",
  },
  REAL_TIME: {
    BASE: "/realtime/",
  },
  IBF: {
    BASE: "/ibf",
  },
  RISK_INFO: {
    BASE: "/risk-info/",
  },
  DATA_ARCHIVE: {
    BASE: "/data-archive/",
  },
  ABOUT: "/about",
  DEVELOPERS: "/developers/",
  MANUALS: "/manuals/",
  FAQS: "/faqs/",
  DRRM_REPORT: "/drrm-report/",
  VIS_RISK: "/vis-risk/",
  FOUR_ZERO_THREE: "/403/",
  SET_NEW_PASSWORD: "/set-new-password/",
};
